import { useEffect, useState } from 'react';
import { getDefaultOverviewMatchId } from '../utils/matches';

export const selectMatch = (matchId) => {
  window.bbSelectedGatheringId = matchId || null;
  window.bbSelectedMatchId = matchId || null;
  window.dispatchEvent(new CustomEvent('bb:gathering-selected', {
    detail: { gatheringId: matchId || null },
  }));
  window.dispatchEvent(new CustomEvent('bb:match-selected', {
    detail: { matchId: matchId || null },
  }));
};

// Header, overzicht en bestellen gebruiken dezelfde handmatige of automatische keuze.
export default function useSelectedMatch(matches) {
  const [selectedId, setSelectedId] = useState(() => window.bbSelectedMatchId || null);

  useEffect(() => {
    const handleSelection = (event) => setSelectedId(event.detail?.matchId || null);
    window.addEventListener('bb:match-selected', handleSelection);
    setSelectedId(window.bbSelectedMatchId || null);
    return () => window.removeEventListener('bb:match-selected', handleSelection);
  }, []);

  return matches.some((match) => match.id === selectedId)
    ? selectedId
    : getDefaultOverviewMatchId(matches);
}
